// Aurora hooks for projects with corporate styling
import { useQuery } from '@tanstack/react-query';
import { projectApi } from '@/lib/client';

interface UseProjectsParams {
    search?: string;
    page?: number;
    limit?: number;
    status?: 'COMPLETED' | 'IN_PROGRESS' | 'PLANNING' | 'ON_HOLD';
    sortBy?: 'createdAt' | 'startDate' | 'endDate' | 'title';
    sortOrder?: 'asc' | 'desc';
}

export const useProjects = (params: UseProjectsParams = {}) => {
    return useQuery({
        queryKey: ['projects', params],
        queryFn: async () => {
            try {
                const res = await projectApi.getProjects({
                    search: params.search,
                    page: params.page,
                    limit: params.limit,
                    status: params.status,
                    sortBy: params.sortBy,
                    sortOrder: params.sortOrder,
                });
                console.log('Aurora Projects API response:', res);
                return res;
            } catch (error) {
                console.error('Aurora Projects API error:', error);
                throw error;
            }
        },
        retry: 1,
        staleTime: 5 * 60 * 1000, // 5 minutes
    });
};

export const useProjectBySlug = (slug: string) => {
    return useQuery({
        queryKey: ['project', slug],
        queryFn: () => projectApi.getProjectBySlug(slug),
        enabled: !!slug,
        retry: 1,
        staleTime: 5 * 60 * 1000,
    });
};

export const useProjectById = (id: string) => {
    return useQuery({
        queryKey: ['project', id],
        queryFn: () => projectApi.getProjectById(id),
        enabled: !!id,
        retry: 1,
        staleTime: 5 * 60 * 1000,
    });
};
